export const germanTranslations = {
  de: {
    'Account recovery requires verified contact information':
      'Kontowiederherstellung erfordert verifizierte Kontaktinformationen',
    'Back to Sign In': 'Zurück zur Anmeldung',
    'Change Password': 'Passwort ändern',
    'Changing password...': 'Passwort wird geändert...',
    Code: 'Bestätigungscode',
    'Confirm Password': 'Passwort bestätigen',
    'Confirm Sign Up': 'Registrierung bestätigen',
    'Confirm SMS Code': 'SMS Code bestätigen',
    'Confirm TOTP Code': 'TOTP Code bestätigen',
    Confirm: 'Bestätigen',
    'Confirming...': 'Wird bestätigt...',
    'Create a new account': 'Neuen Account anlegen',
    'Create Account': 'Account erstellen',
    'Creating Account...': 'Account wird erstellt...',
    Email: 'E-Mail-Adresse',
    'Enter your code': 'Bestätigungscode eingeben',
    'Enter your email': 'E-Mail-Adresse eingeben',
    'Enter your password': 'Passwort eingeben',
    'Forgot your password?': 'Passwort vergessen?',
    'Hide password': 'Passwort verbergen',
    'Invalid verification code provided, please try again.':
      'Ungültiger Bestätigungscode angegeben. Bitte versuchen Sie es erneut.',
    'It may take a minute to arrive':
      'Es kann eine Minute dauern, bis es ankommt',
    'Lost your code?': 'Bestätigungscode verloren?',
    'New password': 'Neues Passwort',
    Password: 'Passwort',
    'Please confirm your password': 'Bitte bestätigen Sie Ihr Passwort',
    'Resend Code': 'Bestätigungscode erneut senden',
    'Reset your password': 'Ihr Passwort zurücksetzen',
    'Reset your Password': 'Ihr Passwort zurücksetzen',
    'Send code': 'Code senden',
    'Sending...': 'Wird gesendet...',
    'Setup TOTP': 'TOTP einrichten',
    'Show password': 'Passwort anzeigen',
    'Sign in to your account': 'Melden Sie sich bei Ihrem Konto an',
    'Sign In': 'Anmelden',
    'Sign in': 'Anmelden',
    'Signing in...': 'Anmeldung läuft...',
    'Sign Out': 'Abmelden',
    'Sign Up': 'Registrieren',
    Submit: 'Bestätigen',
    'Submitting...': 'Wird übermittelt...',
    Username: 'Benutzername',
    'Verify Contact': 'Kontakt verifizieren',
    Verify: 'Verifizieren',
    'We Emailed You': 'Wir haben Ihnen eine E-Mail gesendet',
    'We Sent A Code': 'Wir haben einen Code gesendet',
    'We Texted You': 'Wir haben Ihnen eine SMS gesendet',
    'Your code is on the way. To log in, enter the code we emailed to':
      'Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir per E-Mail gesendet haben an',
    'Your code is on the way. To log in, enter the code we sent you':
      'Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben',
    'Your code is on the way. To log in, enter the code we texted to':
      'Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir per SMS gesendet haben an',

    // Error messages
    'User does not exist.': 'Benutzer existiert nicht.',
    'User already exists': 'Dieser Benutzer existiert bereits',
    'Incorrect username or password.':
      'Ungültige E-Mail-Adresse oder ungültiges Passwort',
    'Invalid password format': 'Ungültiges Passwort-Format',
    'Password did not conform with policy: Password not long enough':
      'Passwort entsprach nicht der Richtlinie: Passwort nicht lang genug',
    'Password attempts exceeded':
      'Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht',
    'Attempt limit exceeded, please try after some time.':
      'Versuchslimit überschritten, bitte versuchen Sie es nach einiger Zeit.',
    'Network error': 'Netzwerkfehler',
    'An account with the given email already exists.':
      'Ein Konto mit der angegebenen E-Mail existiert bereits',
    'Username cannot be empty': 'Benutzername darf nicht leer sein',

    // Additional common translations
    'Have an account? ': 'Sie sind bereits registriert? ',
    'No account? ': 'Noch kein Account? ',
    'Reset Password': 'Passwort zurücksetzen',
    'Enter your Email': 'E-Mail-Adresse eingeben',
    'Enter your Password': 'Passwort eingeben',
  },
}

// Keep old translations for backward compatibility if still used elsewhere
const CognitoTranslations = {
  USER_NOT_EXIST: 'User does not exist.',
  USER_ALREADY_EXIST: 'User already exists.',
  ACCOUNT_EMAIL_EXIST: 'An account with the given email already exists.',
  INVALID_PWD_FORMAT: 'Invalid password format.',
  INVALID_PWD_LENGTH:
    'Password did not conform with policy: Password not long enough',
  INVALID_USERNAME_CLIENT: 'Username/client id combination not found.',
  INVALID_USERNAME_PWD: 'Incorrect username or password.',
  PWD_ATTEMPTS_EXCEEDED: 'Password attempts exceeded.',
  INVALID_VERIFICATION_CODE:
    'Invalid verification code provided, please try again.',
  REGISTER_NOT_VERIFIED:
    'Cannot reset password for the user as there is no registered/verified email or phone_number',
  ATTEMPT_LIMIT_EXCEED: 'Attempt limit exceeded, please try after some time.',
}

// Legacy translations object - keep for backward compatibility
const AmplifyTranslations = {
  [CognitoTranslations.USER_ALREADY_EXIST]: 'Dieser Benutzer existiert bereits',
  [CognitoTranslations.ACCOUNT_EMAIL_EXIST]:
    'Ein Konto mit der angegebenen E-Mail existiert bereits',
  [CognitoTranslations.INVALID_PWD_FORMAT]: 'Ungültiges Passwort-Format',
  [CognitoTranslations.INVALID_PWD_LENGTH]:
    'Passwort entsprach nicht der Richtlinie: Passwort nicht lang genug',
  [CognitoTranslations.INVALID_USERNAME_CLIENT]: 'E-Mail nicht gefunden.',
  [CognitoTranslations.USER_NOT_EXIST]:
    'Account nicht gefunden. Falls Sie Ihren Account gerade erst angelegt haben, aktivieren Sie ihn bitte durch die Eingabe des Bestätigungscodes, den Sie per E-Mail erhalten haben. Sollten Sie noch keinen Account haben, registrieren Sie sich bitte und loggen Sie sich danach ein.',
  [CognitoTranslations.INVALID_USERNAME_PWD]:
    'Ungültige E-Mail-Adresse oder ungültiges Passwort',
  [CognitoTranslations.PWD_ATTEMPTS_EXCEEDED]:
    'Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht',
  [CognitoTranslations.INVALID_VERIFICATION_CODE]:
    'Ungültiger Bestätigungscode angegeben. Bitte versuchen Sie es erneut.',
  [CognitoTranslations.REGISTER_NOT_VERIFIED]:
    'Passwort für den Benutzer kann nicht zurückgesetzt werden, da keine registrierte/verifizierte E-Mail vorhanden ist',
  [CognitoTranslations.ATTEMPT_LIMIT_EXCEED]:
    'Versuchslimit überschritten, bitte versuchen Sie es nach einiger Zeit.',
}

export default AmplifyTranslations
